import React, { useState } from 'react';
import axios from 'axios';
import './BaziResult.css';

const GAN_COLOR = {
  '甲': '#4caf50', '乙': '#4caf50',
  '丙': '#f44336', '丁': '#f44336',
  '戊': '#ff9800', '己': '#ff9800',
  '庚': '#9e9e9e', '辛': '#9e9e9e',
  '壬': '#2196f3', '癸': '#2196f3',
};
const ZHI_COLOR = {
  '子': '#2196f3', '亥': '#2196f3',
  '寅': '#4caf50', '卯': '#4caf50',
  '巳': '#f44336', '午': '#f44336',
  '丑': '#ff9800', '辰': '#ff9800', '未': '#ff9800', '戌': '#ff9800',
  '申': '#9e9e9e', '酉': '#9e9e9e',
};
const SHISHEN_COLOR = {
  '比': '#4caf50', '劫': '#66bb6a',
  '食': '#ff9800', '伤': '#ffa726',
  '财': '#f44336', '才': '#ef5350',
  '官': '#9c27b0', '杀': '#ab47bc',
  '印': '#2196f3', '枭': '#42a5f5',
  '日': '#c8a96e',
};

function GanZhiCell({ gan, zhi, shishen, shishenZ, nayin, isKong, label }) {
  return (
    <div className={`gz-cell${isKong ? ' is-kong' : ''}`}>
      <div className="gz-label">{label}</div>
      <div className="shishen" style={{ color: SHISHEN_COLOR[shishen] || '#aaa' }}>{shishen}</div>
      <div className="gan" style={{ color: GAN_COLOR[gan] || '#e0e0e0' }}>{gan}</div>
      <div className={`zhi${isKong ? ' kong' : ''}`} style={{ color: ZHI_COLOR[zhi] || '#e0e0e0' }}>
        {zhi}
        {isKong && <span className="kong-mark">空</span>}
      </div>
      {shishenZ && shishenZ !== '元' && (
        <div className="shishen-z" style={{ color: SHISHEN_COLOR[shishenZ] || '#aaa' }}>{shishenZ}</div>
      )}
      <div className="nayin">{nayin}</div>
    </div>
  );
}

// 流月弹窗
function LiuyueModal({ liunianYear, lnGanIdx, rgIdx, onClose }) {
  const [liuyue, setLiuyue] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selMonth, setSelMonth] = useState(null);

  React.useEffect(() => {
    setLoading(true);
    setSelMonth(null);
    axios.post('/api/liuyue', { liunianYear, lnGanIdx, rgIdx })
      .then(res => { setLiuyue(res.data.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [liunianYear, lnGanIdx, rgIdx]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box liuyue-modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <span>{liunianYear}年流月运程</span>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        {loading && <div className="modal-loading">加载中...</div>}
        {liuyue && (
          <>
            <div className="liuyue-grid">
              {liuyue.map((m, i) => (
                <div
                  key={i}
                  className={`liuyue-item${selMonth === i ? ' ly-selected' : ''}`}
                  onClick={() => setSelMonth(selMonth === i ? null : i)}
                >
                  <div className="ly-no">第{m.no}月</div>
                  <div className="ly-term">{m.termName} {m.termDate}</div>
                  <div className="ly-gz">
                    <span style={{ color: GAN_COLOR[m.ganZhi[0]] || '#e0e0e0' }}>{m.ganZhi[0]}</span>
                    <span style={{ color: ZHI_COLOR[m.ganZhi[1]] || '#e0e0e0' }}>{m.ganZhi[1]}</span>
                  </div>
                  {m.shishen && <div className="ly-shishen">{m.shishen}</div>}
                </div>
              ))}
            </div>
            {selMonth !== null && liuyue[selMonth] && liuyue[selMonth].lyText && (
              <div className="ly-text-panel">
                <div className="ly-text-title">
                  第{liuyue[selMonth].no}月 {liuyue[selMonth].ganZhi} {liuyue[selMonth].shishen}
                </div>
                <div className="ly-text">{liuyue[selMonth].lyText}</div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

// 大运流年作用分析面板
function ZuoyongPanel({ params, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios.post('/api/zuoyong', params)
      .then(res => { setData(res.data.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [params]);

  if (loading) return <div className="zuoyong-panel panel"><div className="modal-loading">分析中...</div></div>;
  if (!data) return null;

  const COLS = ['年柱', '月柱', '日柱', '时柱'];

  return (
    <div className="zuoyong-panel panel">
      <div className="section-title">
        大运流年作用分析
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>
      <div className="zy-header">
        <div className="zy-info">{data.dyInfo}</div>
        <div className="zy-info">{data.lnInfo}</div>
      </div>
      {data.lnShishenNote && (
        <div className="zy-note warn">{data.lnShishenNote}</div>
      )}
      <div className="zy-shishen-row">
        <div className="zy-item">
          <span className="zy-label">大运干：</span>
          <span>{data.dyGanShishen}</span>
        </div>
        <div className="zy-item">
          <span className="zy-label">流年干：</span>
          <span>{data.lnGanShishen}</span>
        </div>
        <div className="zy-item">
          <span className="zy-label">大运支：</span>
          <span>{data.dyZhiShishen}</span>
        </div>
        <div className="zy-item">
          <span className="zy-label">流年支：</span>
          <span>{data.lnZhiShishen}</span>
        </div>
      </div>
      <div className="zy-nature">{data.lnynzuoyong}</div>

      {/* 天干作用 */}
      <div className="zy-section-title">天干作用关系</div>
      <div className="zy-rel-row">
        <div className="zy-rel-box">
          <div className="zy-rel-label">流年→大运</div>
          <div className="zy-rel-text">{data.result_dyg}</div>
        </div>
        {data.result_lng && (
          <div className="zy-rel-box">
            <div className="zy-rel-label">大运→流年</div>
            <div className="zy-rel-text">{data.result_lng}</div>
          </div>
        )}
      </div>
      <div className="zy-cols-grid">
        {COLS.map((col, i) => (
          <div key={i} className="zy-col-item">
            <div className="zy-col-name">{col}</div>
            <div className="zy-col-result">{data.result_g[i] || '—'}</div>
            <div className={`zy-arrow${data.gbjColor[i] ? ' red' : ''}`}>{data.gbj[i]}</div>
          </div>
        ))}
      </div>

      {/* 地支作用 */}
      <div className="zy-section-title">地支作用关系</div>
      {data.dyz_buding && <div className="zy-note">{data.dyz_buding}</div>}
      {data.lnz_buding && <div className="zy-note warn">{data.lnz_buding}</div>}
      <div className="zy-rel-row">
        <div className="zy-rel-box">
          <div className="zy-rel-label">流年→大运</div>
          <div className="zy-rel-text">{data.result_dyz}</div>
        </div>
        {data.result_lnz && (
          <div className="zy-rel-box">
            <div className="zy-rel-label">大运→流年</div>
            <div className="zy-rel-text">{data.result_lnz}</div>
          </div>
        )}
      </div>
      <div className="zy-cols-grid">
        {COLS.map((col, i) => (
          <div key={i} className="zy-col-item">
            <div className="zy-col-name">{col}</div>
            <div className="zy-col-result">{data.result_z[i] || '—'}</div>
            <div className="zy-arrow">{data.zbj[i]}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function BaziResult({ result }) {
  const { input, sizhu, xunkong, geju, gejuStr, gejuInfo, mjfxText, qiyun, dayun, liunian, chenggu } = result;
  const [selDayun, setSelDayun] = useState(0);
  const [showLiunian, setShowLiunian] = useState(false);
  const [liuyueTarget, setLiuyueTarget] = useState(null); // { year, ganIdx }
  const [zuoyongParams, setZuoyongParams] = useState(null);


  const thisYear = new Date().getFullYear();

  const currentDayunLiunian = liunian.filter(
    ln => ln.dayunGanZhi === dayun[selDayun]?.ganZhi
  );

  const gejuClass = (geju === '身旺' || geju === '从强') ? 'strong' : 'weak';

  function handleLnClick(ln) {
    const dy = dayun[selDayun];
    if (!dy) return;
    const p = {
      ngIdx: sizhu.nian.ganIdx, nzIdx: sizhu.nian.zhiIdx,
      ygIdx: sizhu.yue.ganIdx,  yzIdx: sizhu.yue.zhiIdx,
      rgIdx: sizhu.ri.ganIdx,   rzIdx: sizhu.ri.zhiIdx,
      sgIdx: sizhu.shi.ganIdx,  szIdx: sizhu.shi.zhiIdx,
      dyGanIdx: dy.ganIdx, dyZhiIdx: dy.zhiIdx,
      lnGanIdx: ln.ganIdx, lnZhiIdx: ln.zhiIdx,
      xunkong1: xunkong.zhi1, xunkong2: xunkong.zhi2,
      ysng: gejuInfo?.ysng || false, ysyg: gejuInfo?.ysyg || false,
      ysrz: gejuInfo?.ysrz || false, yssg: gejuInfo?.yssg || false,
      ylxk: sizhu.yue.isKong, szxk: sizhu.shi.isKong,
      liunianYear: ln.year,
      dyStartYear: dy.startYear, dyEndYear: dy.endYear,
    };
    setZuoyongParams(p);
  }

  return (
    <div className="bazi-result">
      {/* 基本信息 */}
      <div className="result-header panel">
        <div className="person-info">
          <span className="person-name">{input.name}</span>
          <span className={`gender-badge ${input.gender === '男' ? 'male' : 'female'}`}>
            {input.gender === '男' ? '乾造' : '坤造'}
          </span>
        </div>
        <div className="birth-info">
          公历 {input.year}年{input.month}月{input.day}日 {String(input.hour).padStart(2,'0')}:{String(input.minute).padStart(2,'0')}
        </div>
        <div className="geju-badge-row">
          <span className={`geju-badge ${gejuClass}`}>{geju}</span>
          <span className="xunkong-info">旬空：{xunkong.zhi1}、{xunkong.zhi2}</span>
        </div>
      </div>

      {/* 四柱 */}
      <div className="sizhu-section panel">
        <h2 className="section-title">四柱八字</h2>
        <div className="sizhu-grid">
          <GanZhiCell {...sizhu.nian} label="年柱" />
          <GanZhiCell {...sizhu.yue} label="月柱" />
          <GanZhiCell {...sizhu.ri}  label="日柱" />
          <GanZhiCell {...sizhu.shi} label="时柱" />
        </div>
      </div>

      {/* 起运 & 大运 */}
      <div className="yunqi-section panel">
        <h2 className="section-title">大运</h2>
        <div className="qiyun-info">
          <span>起运：命主从 <strong>{qiyun.desc}</strong> 起运</span>
          <span className="sep">｜</span>
          <span>交运：公历 <strong>{qiyun.jiaoyunYear}年{qiyun.jiaoyunMonth}月{qiyun.jiaoyunDays}日</strong></span>
          <span className="sep">｜</span>
          <span>行运：<strong>{qiyun.forward ? '顺行' : '逆行'}</strong></span>
        </div>
        <div className="dayun-list">
          {dayun.map((dy, i) => {
            const isActive = dy.startYear <= thisYear && (dy.startYear + 10) > thisYear;
            return (
              <div
                key={i}
                className={`dayun-item${i === selDayun ? ' selected' : ''}${isActive ? ' current' : ''}`}
                onClick={() => { setSelDayun(i); setShowLiunian(true); setZuoyongParams(null); }}
              >
                <div className="dy-age">{dy.startAge}岁</div>
                <div className="dy-year">{dy.startYear}年</div>
                <div className="dy-gan" style={{ color: GAN_COLOR[dy.ganZhi[0]] || '#e0e0e0' }}>{dy.ganZhi[0]}</div>
                <div className="dy-zhi" style={{ color: ZHI_COLOR[dy.ganZhi[1]] || '#e0e0e0' }}>{dy.ganZhi[1]}</div>
                {isActive && <div className="current-mark">当前</div>}
              </div>
            );
          })}
        </div>
      </div>

      {/* 流年 */}
      {showLiunian && currentDayunLiunian.length > 0 && (
        <div className="liunian-section panel">
          <h2 className="section-title">
            流年运程
            <span className="sub-title"> — 第{selDayun+1}步运 {dayun[selDayun]?.ganZhi}</span>
            <button className="close-btn" onClick={() => { setShowLiunian(false); setZuoyongParams(null); }}>✕</button>
          </h2>
          <div className="liunian-list">
            {currentDayunLiunian.map((ln, i) => {
              const isCurYear = ln.year === thisYear;
              const isSelZuoyong = zuoyongParams && zuoyongParams.liunianYear === ln.year;
              return (
                <div
                  key={i}
                  className={`ln-row${isCurYear ? ' current-year' : ''}${isSelZuoyong ? ' sel-zuoyong' : ''}`}
                >
                  <div className="ln-row-head" onClick={() => handleLnClick(ln)}>
                    <span className="ln-row-year">{ln.year}{isCurYear && <span className="cur-year-mark">今</span>}</span>
                    <span className="ln-row-age">{ln.age}岁</span>
                    <span className="ln-row-gz">
                      <span style={{ color: GAN_COLOR[ln.ganZhi[0]] || '#e0e0e0' }}>{ln.ganZhi[0]}</span>
                      <span style={{ color: ZHI_COLOR[ln.ganZhi[1]] || '#e0e0e0' }}>{ln.ganZhi[1]}</span>
                    </span>
                    <span className="ln-row-nayin">{ln.nayin}</span>
                    <span className="ln-row-shishen">{ln.lnShishen}</span>
                    <span className="ln-row-btns">
                      <button
                        className="ly-btn"
                        title="查看流月"
                        onClick={e => { e.stopPropagation(); setLiuyueTarget({ year: ln.year, ganIdx: ln.ganIdx, rgIdx: sizhu.ri.ganIdx }); }}
                      >月</button>
                    </span>
                  </div>
                  {ln.dynText && (
                    <div className="ln-row-dyntext">{ln.dynText}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* 大运流年作用分析 */}
      {zuoyongParams && (
        <ZuoyongPanel params={zuoyongParams} onClose={() => setZuoyongParams(null)} />
      )}

      {/* 格局分析 */}
      <div className="geju-section panel">
        <h2 className="section-title">格局分析</h2>
        <div className="geju-content">
          <div className={`geju-main ${gejuClass}`}>
            <span className="geju-icon">{gejuClass === 'strong' ? '△' : '▽'}</span>
            <span className="geju-text">{geju}</span>
          </div>
          {gejuStr && <div className="geju-str">{gejuStr}</div>}
          {gejuInfo && (
            <div className="yongshen-row">
              <span className="ys-label">用神：</span>
              {gejuInfo.ysng && <span className="ys-tag">年干 {sizhu.nian.gan}</span>}
              {gejuInfo.ysyg && <span className="ys-tag">月干 {sizhu.yue.gan}</span>}
              {gejuInfo.ysrz && <span className="ys-tag">日支 {sizhu.ri.zhi}</span>}
              {gejuInfo.yssg && <span className="ys-tag">时干 {sizhu.shi.gan}</span>}
              {!gejuInfo.ysng && !gejuInfo.ysyg && !gejuInfo.ysrz && !gejuInfo.yssg && <span className="ys-none">无</span>}
              <span className="ys-label" style={{marginLeft:16}}>忌神：</span>
              {!gejuInfo.ysng && <span className="js-tag">年干 {sizhu.nian.gan}</span>}
              {!gejuInfo.ysyg && <span className="js-tag">月干 {sizhu.yue.gan}</span>}
              {!gejuInfo.ysrz && <span className="js-tag">日支 {sizhu.ri.zhi}</span>}
              {!gejuInfo.yssg && <span className="js-tag">时干 {sizhu.shi.gan}</span>}
            </div>
          )}
          <div className="xunkong-detail">
            <span>空亡：</span>
            <span className="kong-zhi">{xunkong.zhi1}</span>
            <span>、</span>
            <span className="kong-zhi">{xunkong.zhi2}</span>
            <span className="kong-note">（月令{sizhu.yue.isKong ? '空亡' : '不空'}，时支{sizhu.shi.isKong ? '空亡' : '不空'}）</span>
          </div>
        </div>
      </div>

      {/* 命局分析 */}
      {mjfxText && (
        <div className="mjfx-section panel">
          <h2 className="section-title">命局分析</h2>
          <div className="mjfx-text">{mjfxText}</div>
        </div>
      )}

      {/* 称骨算命 */}
      {chenggu && (
        <div className="chenggu-section panel">
          <h2 className="section-title">称骨算命（袁天罡）</h2>
          <div className="cg-weight">骨重：<strong>{chenggu.zcount} 两</strong></div>
          <div className="cg-text">
            {chenggu.text.split('\n').map((line, i) => (
              <p key={i} className={i === 0 ? 'cg-title' : i === 1 ? 'cg-name' : line.startsWith('注解') ? 'cg-note' : 'cg-poem'}>{line}</p>
            ))}
          </div>
        </div>
      )}



      {/* 流月弹窗 */}
      {liuyueTarget && (
        <LiuyueModal
          liunianYear={liuyueTarget.year}
          lnGanIdx={liuyueTarget.ganIdx}
          rgIdx={liuyueTarget.rgIdx}
          onClose={() => setLiuyueTarget(null)}
        />
      )}
    </div>
  );
}
